import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type Timeframe = "24h" | "7d" | "30d";

export type TrendTopic = {
  id: string;
  topic: string;
  focus_area: string | null;
  timeframe: Timeframe;
  volume: number;
  momentum_pct: number;
  top_platform: string | null;
  geo_top_county: string | null;
  geo_top_county_share: number | null;
  sentiment_pos: number;
  sentiment_neu: number;
  sentiment_neg: number;
  platform_breakdown: Record<string, number> | null;
  updated_at: string;
};

export function useTrendTopics(timeframe: Timeframe = "7d") {
  return useQuery({
    queryKey: ["trend_topics", timeframe],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("trend_topics")
        .select("*")
        .eq("timeframe", timeframe)
        .order("momentum_pct", { ascending: false });
      if (error) throw error;
      return (data ?? []) as unknown as TrendTopic[];
    },
    staleTime: 5 * 60 * 1000,
  });
}